"use client";

import React, { createContext, useState } from "react";
import { GlobalContextProps } from "./types";
export const GlobalContext = createContext<GlobalContextProps>({} as any);

export const GlobalProvider = ({
  children,
  siteDatafromProps,
  configDataFromProps,
  siteDataCompleteFromProps,
  t,
  language,
  sourceURL,
}: any) => {
  const [context, setContext] = useState<any>({
    siteData: siteDatafromProps,
    configData: configDataFromProps,
    siteDataComplete: siteDataCompleteFromProps,
    t: t,
    language: language,
    sourceURL: sourceURL,
  });

  return (
    <GlobalContext.Provider value={{ context, setContext }}>{children}</GlobalContext.Provider>
  );
};
